import { render, staticRenderFns } from "./ProjectCardOverview.vue?vue&type=template&id=47c71eea&scoped=true"
import script from "./ProjectCardOverview.vue?vue&type=script&lang=js"
export * from "./ProjectCardOverview.vue?vue&type=script&lang=js"
import style0 from "./ProjectCardOverview.vue?vue&type=style&index=0&id=47c71eea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c71eea",
  null
  
)

export default component.exports